<!-- eslint-disable vue/max-attributes-per-line -->
<template>
    <div class="content__page h--100 relative min-h-inherit">
        <template v-if="!accountPlan || accountPlan === 'free'">
            <EmptyPage 
                state="empty_custom" 
                icon-name="money" 
                btn-state="custom"
                type="data"
                position="left"
                title="This is a paid feature"
                subtitle="Unlock insights into your revenue growth as a freelancer. Upgrade to a paid plan to get access to this feature" 
            >
                <template #button>
                    <BaseButton 
                        label="Go to account settings" 
                        :show-spinner="false"
                        @submit="goToAccountSettings"
                    />
                </template>
            </EmptyPage>
        </template>

        <template v-else>
            <LinkedTabs :list="revenueTabList" class="h--100" type="single_pill" is-icon position="end" />
        </template>
    </div>
</template>

<script>
import { LinkedTabs, EmptyPage, BaseButton } from "@/components/ui/index";
import { revenueTabList } from "@/utils/dummy";

export default {
    name: "Revenue",

    components: {
        LinkedTabs,
        EmptyPage,
        BaseButton,
    },

    data() {
        return {
            revenueTabList,
        };
    },

    computed: {
        currentYear() {
            return this.$store.getters["revenue/currentYear"];
        },

        accountPlan() {
            return this.$store.getters["subscription/subscriptionInfo"]?.plan || "free";
        },
    },

    methods: {
        goToAccountSettings() {
            this.$router.push("/dashboard/settings/payments-and-billings");
        },

        getPathTitle() {
            const splitPaths = this.$route.path.split("/");
            return splitPaths[splitPaths.length - 1] || "";
        },
    },
};
</script>